import type React from 'react';
// Order matters: react-global sets window.React first…
import './react-global';
// …then the DS bundle IIFE runs and populates window.CarrTechAIDesignSystem_ad3660.
import '../../design-source/ds/_ds_bundle.js';

type C = React.ComponentType<any>;

const NS: Record<string, C> = (window.CarrTechAIDesignSystem_ad3660 ?? {}) as Record<string, C>;

function req(name: string): C {
  const c = NS[name];
  if (!c) {
    // Fail loud in dev: a missing DS component means the bundle didn't load.
    throw new Error(`DS component "${name}" missing from the design-system bundle.`);
  }
  return c;
}

// The 26 design-system components (window.CarrTechAIDesignSystem_ad3660).
// core
export const Badge = req('Badge');
export const Button = req('Button');
export const Card = req('Card');
export const Compass = req('Compass');
export const IconButton = req('IconButton');
export const Kicker = req('Kicker');
export const Logo = req('Logo');
export const StatusPill = req('StatusPill');
export const Tag = req('Tag');
// data
export const ActivityItem = req('ActivityItem');
export const StatCard = req('StatCard');
export const Table = req('Table');
// feedback
export const Dialog = req('Dialog');
export const ProgressBar = req('ProgressBar');
export const Spinner = req('Spinner');
export const Toast = req('Toast');
export const Tooltip = req('Tooltip');
// forms
export const Checkbox = req('Checkbox');
export const Input = req('Input');
export const Radio = req('Radio');
export const Select = req('Select');
export const Switch = req('Switch');
export const Textarea = req('Textarea');
// navigation
export const Avatar = req('Avatar');
export const SidebarItem = req('SidebarItem');
export const Tabs = req('Tabs');
